import { IAdminCommunitiesState } from 'types/store/admin/communities';

export const initState: IAdminCommunitiesState = {
  pendingCommunities: null,
  isPendingCommunitiesLoading: false,
  community: null,
};
